import { TableColumn } from 'tea-component';
import { getFormatNumPlus } from '@gp/utils/common';

const getColumns = (colList: string[]): TableColumn<any>[] => {
  const opt: TableColumn<any>[] = [
    {
      key: 'date',
      header: 'Date',
      width: 160,
      align: 'left',
      fixed: 'left',
      render: (cvm: any) => {
        return cvm?.date || '-';
      },
    },
  ];
  if (Array.isArray(colList) && colList?.length) {
    for (let i = 0; i < colList?.length; i++) {
      const t: string = colList?.[i];
      opt.push({
        key: t,
        header: t,
        width: 200,
        align: 'right',
        render: (cvm: any) => {
          return getFormatNumPlus(cvm?.[t]);
        },
      });
    }
  }
  // 添加最后一列空列
  opt.push({
    key: 'empty',
    header: '',
    width: 60,
    align: 'right',
    render: (cvm: any) => '',
  });

  return opt;
};

export { getColumns };
